export { default } from './ProductOrigin';
